export default __webpack_public_path__ + "83691856f28a49e492b1f239ac6d91fb.png";